// client/src/coms/components/comslayout_parts/serverNavPrefs.js
import { useEffect, useState } from 'react';

export const LS_SERVER_NAV_MODE = 'vox:serverNavMode';
export const SERVER_NAV_MODE_EVENT = 'vox-server-nav-mode-changed';

export const SERVER_NAV_DROPDOWN = 'dropdown';
export const SERVER_NAV_SIDEBAR = 'sidebar';
export const DEFAULT_SERVER_NAV_MODE = SERVER_NAV_DROPDOWN;

export function normalizeServerNavMode(v) {
  return String(v || '').trim().toLowerCase() === SERVER_NAV_SIDEBAR ? SERVER_NAV_SIDEBAR : SERVER_NAV_DROPDOWN;
}

export function readServerNavMode() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return DEFAULT_SERVER_NAV_MODE;
    return normalizeServerNavMode(window.localStorage.getItem(LS_SERVER_NAV_MODE));
  } catch {
    return DEFAULT_SERVER_NAV_MODE;
  }
}

export function writeServerNavMode(mode) {
  const next = normalizeServerNavMode(mode);
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      if (next === DEFAULT_SERVER_NAV_MODE) window.localStorage.removeItem(LS_SERVER_NAV_MODE);
      else window.localStorage.setItem(LS_SERVER_NAV_MODE, next);
    }
  } catch {}

  try {
    window.dispatchEvent(new CustomEvent(SERVER_NAV_MODE_EVENT, { detail: { mode: next } }));
  } catch {}

  return next;
}

// Current server navigation layout. Updates live when changed in Settings or in another tab.
export default function useServerNavMode() {
  const [mode, setMode] = useState(() => readServerNavMode());

  useEffect(() => {
    function onChanged(e) {
      const fromEvent = e && e.detail && e.detail.mode;
      setMode(fromEvent ? normalizeServerNavMode(fromEvent) : readServerNavMode());
    }

    function onStorage(e) {
      if (!e || e.key === LS_SERVER_NAV_MODE || e.key === null) setMode(readServerNavMode());
    }

    window.addEventListener(SERVER_NAV_MODE_EVENT, onChanged);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(SERVER_NAV_MODE_EVENT, onChanged);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return mode;
}
